import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type BlogPostListItem = ResultOf<
  typeof blogPostListQuery
>["blogPosts"]["data"][number];

export const blogPostListQuery = graphql(`
  query BlogPostList(
    $first: Int!
    $page: Int
    $tagId: ID
    $authorId: ID
    $search: String
    $publishedOnly: Boolean
    $audience: BlogAudience
    $status: BlogPostStatus
    $orderBy: [QueryBlogPostsOrderByOrderByClause!]
  ) {
    blogPosts(
      first: $first
      page: $page
      tagId: $tagId
      authorId: $authorId
      search: $search
      publishedOnly: $publishedOnly
      audience: $audience
      status: $status
      orderBy: $orderBy
    ) {
      data {
        id
        slug
        title
        excerpt
        locale
        hero_image {
          ...MediaFields
        }
        published_at
        is_published
        audience
        reading_time_minutes
        author {
          id
          name
        }
        tags {
          id
          name
        }
        created_at
        updated_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
